<template>
  <div class="page-style-a">
    <div class="container">
      <div class="page-intro">
        <h2>Waiting</h2>
        <ul class="bread-crumb">
          <li class="has-separator">
            <i class="ion ion-md-home"></i>
            <router-link :to="{name : 'Home'}">Home</router-link>
          </li>
          <li class="is-marked">
            <a href="checkout.html">Waiting</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row" style="justify-content: center">
      <div class="col-6">
        <div class="product-not-found">
          <div class="text-center" v-if="!showTimer">
            <h1>Order Cancelled!</h1>
            <h5>
              Order Cancelled Successfully. Your order ID is : OD-{{
                getPlacedOrderId
              }}-{{ Date.now() }}
            </h5>
            <a href="/" class="thank-you-back">Back to homepage</a>
          </div>
          <div class="not-found" v-if="showTimer">
            <h2>{{ milliToMinutes }}</h2>
            <h6>Please Wait.</h6>
            <button
              type="button"
              class="button button-outline-secondary"
              @click="handleCancel"
              :disabled="loading"
            >
              {{ loading ? "Please Wait.." : "Cancel" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import axios from "axios";
import Footer from "../components/Bottom/Footer.vue";
import { mapGetters } from "vuex";
export default {
  components: { Footer },

  data() {
    return {
      timer: 10000,
      showTimer: true,
      interval: "",
      loading: false,
      token: localStorage.getItem("token"),
    };
  },
  computed: {
    ...mapGetters("orders", ["getPlacedOrderId"]),
    milliToMinutes() {
      return this.millisToMinutesAndSeconds(this.timer);
    },
  },
  methods: {
    millisToMinutesAndSeconds(millis) {
      var minutes = Math.floor(millis / 60000);
      var seconds = ((millis % 60000) / 1000).toFixed(0);
      return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    },
    countDownTimer() {
      if (this.timer > 0) {
        this.interval = setTimeout(() => {
          this.timer -= 1000;
          this.countDownTimer();
        }, 1000);
      }
    },
    handleCancel() {
      clearInterval(this.interval);
      this.ChangeOrderStatus();
    },
    async ChangeOrderStatus() {
      this.loading = true;
      try {
        let { data } = await axios.post(
          process.env.VUE_APP_API_URL + "/api/frontend/update-order-status",
          { order_id: this.getPlacedOrderId, status: 5 },
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          }
        );
        this.showTimer = false;
        this.loading = false;
        console.log(data);
      } catch (error) {
        console.log(error);
        this.showTimer = false;
        this.loading = false;
      }
    },
  },
  mounted() {
    this.countDownTimer();
  },
  watch: {
    timer: function (val) {
      if (val == 0) {
        this.$router.push({ name: "Thankyou" });
      }
    },
  },
};
</script>

<style>
</style>